export default __webpack_public_path__ + "static/media/holdIT.be458cce.svg";